import { applyHighchartsTheme } from "../utils/highcharts_theme"

export const ProductTypePieChart = {
  mounted() {
    this.handleEvent("render-product-type-pie", ({ pie_data }) => {
      this.renderChart(pie_data)
    })

    // Also render on mount if data is present
    const pieData = this.el.dataset.pieData
    if (pieData) {
      this.renderChart(JSON.parse(pieData))
    }
  },

  renderChart(pieData) {
    import("highcharts").then((Highcharts) => {
      applyHighchartsTheme(Highcharts.default)
      Highcharts.default.chart(this.el.id, {
        chart: {
          type: "pie",
          // Highcharts 13 defaults chart.backgroundColor to a CSS var that
          // renders dark under prefers-color-scheme: dark; keep it explicit.
          backgroundColor: "transparent",
        },
        title: {
          text: null,
        },
        tooltip: {
          pointFormat: "<b>{point.percentage:.1f}%</b><br/>{point.y} proposals",
        },
        accessibility: {
          point: {
            valueSuffix: "%",
          },
        },
        plotOptions: {
          pie: {
            allowPointSelect: true,
            cursor: "pointer",
            dataLabels: {
              enabled: true,
              format: "<b>{point.name}</b>: {point.percentage:.1f}%",
            },
            showInLegend: true,
          },
        },
        series: [
          {
            name: "Product Types",
            colorByPoint: true,
            data: pieData.data,
          },
        ],
        credits: {
          enabled: false,
        },
      })
    })
  },
}
